import { Component } from 'react';
import { PoolSelect, SelectOption } from '@synergy/components';
import { WithStyles, createStyles, withStyles } from '@mui/styles';

import { Supplier } from '../../../../../common/models/supplier';

const styles = () =>
    createStyles({
        container: {
            padding: 10,
        },
    });

interface OfferEditModalHeaderProps extends WithStyles<typeof styles> {
    suppliers: Supplier[];
    supplierId: number;
    onSupplierChanged: (supplier: Supplier) => void;
}

export const OfferEditModalHeader = withStyles(styles)(
    class OfferEditModalHeaderBase extends Component<OfferEditModalHeaderProps> {
        private handleSupplierChanged = (supplierId: number) => {
            const foundSupplier = this.props.suppliers.find(supplier => supplier.id === supplierId);
            if (foundSupplier) {
                this.props.onSupplierChanged(foundSupplier);
            }
        };

        public render() {
            const { classes, suppliers, supplierId } = this.props;
            const options: SelectOption[] = suppliers.map(supplier => ({
                value: supplier.id,
                displayValue: supplier.name,
            }));

            return (
                <div className={classes.container}>
                    <PoolSelect
                        options={options}
                        fullWidth={true}
                        disallowDefaultValue={true}
                        value={supplierId}
                        onValueChange={this.handleSupplierChanged}
                    />
                </div>
            );
        }
    }
);
